import * as React from 'react'
import { PricingService } from './pricingService'

export const PricingServiceContext = React.createContext(null as any as PricingService)
